import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight, Menu, X } from 'lucide-react';

const NAV = [
  { name: 'How it works', path: '/#how-it-works' },
  { name: 'Career paths', path: '/#career-paths' },
  { name: 'Learning', path: '/learning-paths' },
  { name: 'Programs', path: '/programs' },
  { name: 'For Colleges', path: '/for-colleges' },
  { name: 'For Employers', path: '/for-employers' },
];

const Logo = () => (
  <Link to="/" className="shrink-0 bg-white rounded-xl px-3 py-1.5 shadow-sm" data-testid="header-logo">
    <img src="/logo-elevate-careers.webp" alt="Elevate Careers" className="h-8 w-auto" />
  </Link>
);

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    setOpen(false);
    if (location.hash) document.querySelector(location.hash)?.scrollIntoView({ behavior: 'smooth' });
  }, [location.pathname, location.hash]);

  return (
    <header data-testid="site-header"
      className={`${location.pathname === '/' ? 'fixed' : 'sticky'} top-0 inset-x-0 z-50 transition-[background-color,box-shadow] duration-300 ${scrolled || open || location.pathname !== '/' ? 'bg-[#0b1f4d]/95 backdrop-blur-lg shadow-[0_8px_30px_rgba(0,0,0,0.25)]' : 'bg-[#0b1f4d]/60 backdrop-blur-sm'}`}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center gap-8">
        <Logo />
        <nav className="hidden lg:flex items-center gap-7 flex-1">
          {NAV.map((l) => (
            <Link key={l.name} to={l.path} data-testid={`nav-${l.name.toLowerCase().replace(/[^a-z]+/g, '-')}`}
              className="text-sm text-slate-200 hover:text-teal-300 transition-colors">{l.name}</Link>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-5 ml-auto">
          <Link to="/my-journey" data-testid="header-my-journey" className="text-sm font-semibold text-white hover:text-teal-300 transition-colors">My Career Journey</Link>
          <Link to="/network" data-testid="header-get-started-btn"
            className="group inline-flex items-center gap-2 bg-teal-400 hover:bg-teal-300 text-[#0b1f4d] text-sm font-semibold px-5 py-2.5 rounded-full transition-colors">
            Get Started Free <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
          </Link>
        </div>
        <button onClick={() => setOpen(!open)} className="lg:hidden ml-auto text-white p-2" aria-label="Toggle menu" data-testid="mobile-menu-toggle">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-white/10 px-5 pb-6" data-testid="mobile-menu">
          {NAV.map((l) => <Link key={l.name} to={l.path} className="block py-3 text-slate-200 border-b border-white/5">{l.name}</Link>)}
          <Link to="/my-journey" data-testid="mobile-my-journey" className="block mt-4 py-3 text-center rounded-full border border-white/30 text-white font-semibold">My Career Journey</Link>
          <Link to="/network" data-testid="mobile-get-started-btn" className="block mt-3 py-3 text-center rounded-full bg-teal-400 text-[#0b1f4d] font-semibold">Get Started Free</Link>
        </div>
      )}
    </header>
  );
};

export default Header;
